module.exports = __webpack_public_path__ + "static/media/icon-calendar.da2280e8.svg";